<template>
	<div>
		<v-container fluid pt-0 grid-list-xl>
			<section-tooltip v-if="tempDashboard !== null" :title="tempDashboard.settings.name[$i18n.locale]" :tooltip="tempDashboard.settings.description[$i18n.locale]"></section-tooltip>
			<grid-layout v-if="tempDashboard !== null"
				:layout="widgetLayout"
				:col-num="tempDashboard.settings.columns"
				:row-height="30"
				:is-draggable="false"
				:is-resizable="false"
				:is-mirrored="false"
				:responsive="false"
				:vertical-compact="true"
				:margin="[10, 10]"
				:use-css-transforms="true">
					<grid-item v-for="item in tempDashboard.widgets" :key="item.id"
						:x="item.config.layout.x"
						:y="item.config.layout.y"
						:w="item.config.layout.w"
						:h="item.config.layout.h"
						:i="item.config.layout.i">
						<widget-renderer :widget="item.config" style="width:100%"></widget-renderer>
					</grid-item>
				</grid-layout>
			<div class="no-widget-text" v-if="!tempDashboard || tempDashboard.widgets.length === 0">
				There are no Widgets on this Dashboard.
				<br>
				Please contact your account manager.
			</div>
		</v-container>
	</div>
</template>

<script>
	import { mapGetters } from 'vuex'
	import WidgetRenderer from 'Components/Widgets/widget-renderer'
	import VueGridLayout from 'vue-grid-layout'

	export default {
		components: {
			GridLayout: VueGridLayout.GridLayout,
			GridItem: VueGridLayout.GridItem,
			WidgetRenderer
		},
		data() {
			return {
				tempDashboard: null
			}
		},
		computed: {
			...mapGetters([
				'dashboard',
				'reportingData'
			]),
			widgetLayout: function () {
				return this.tempDashboard.widgets.map(widget => widget.config.layout)
			}
		},
		watch: {
			dashboard (val) {
				this.tempDashboard = Object.assign({}, JSON.parse(JSON.stringify(val)))
			}
		},
		created () {
			this.$store.dispatch('getUserDashboard')
		}
	}
</script>
